export default "__VITE_ASSET__BexzF_0E__"